var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"three-options collection-item",class:[
    {
      'background-notRead': _vm.status === 'P' && _vm.origin !== 'Order_Orderbackend',
    },
    '',
  ],staticStyle:{"width":"100%"},on:{"click":function($event){_vm.click ? _vm.click(_vm.idIcon) : () => {}}}},[_c('div',{attrs:{"id":_vm.idIcon}}),_c('div',{staticClass:"item-middle",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"item-title",staticStyle:{"width":"auto"}},[_c('span',{staticClass:"titulo",staticStyle:{"width":"auto"}},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"data",staticStyle:{"width":"auto"}},[_vm._v(_vm._s(_vm.data))])]),_c('span',{class:{
        'info-adicional': _vm.origin !== 'Evt_EventFavorite',
        'info-adicional-event': _vm.origin === 'Evt_EventFavorite',
      },staticStyle:{"width":"auto"}},[_vm._v(" "+_vm._s(_vm.desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }